export default "__VITE_ASSET__b6bcce2d__"